// /js/services/supabaseClient.js
import { createClient } from 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js/+esm'

// ✅ Your Supabase Project URL (from Data API page)
const supabaseUrl = 'https://uvnzqbmiwgzhjboxkdag.supabase.co';

// ✅ Your Publishable Key (safe for frontend)
const supabasePublishableKey = 'sb_publishable_16BJybl1NM_fR6DDaRoG-g_paVwMxWf';

export const supabase = createClient(supabaseUrl, supabasePublishableKey);